import { FilterButton } from '../buttons/FilterButton';
import { useTranslation } from 'react-i18next';

export const SearchFilter = ({ value, setValue, doFilter }) => {
    const { t } = useTranslation();

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleKeyUp = (event) => {
        if (event.key === 'Enter') {
            doFilter()
        }
    };

    return (
        <div className={'filter'} id={'filter-element'}>
            <div className={'mb-3'}>
                <span>{t('filter:title')}</span>
                <input type={'text'}
                       className={'form-control'}
                       id={'filter-by-title-id'}
                       defaultValue={value}
                       onKeyUp={handleKeyUp}
                       onChange={handleChange} />
            </div>
            <div className={'center'}>
                <FilterButton onClick={doFilter}></FilterButton>
            </div>
        </div>
    );
};